export const TestIds = {
  container: 'quick-questions',
  title: 'quick-questions-title',
  list: 'quick-questions-list',
  item: 'quick-questions-item',
};
